import { Button, Modal } from "react-bootstrap";

export default function MatchConfirmModal({ matchTarget, onConfirm, onCancel, matching }) {
	return (
		<Modal show={!!matchTarget} onHide={onCancel} centered>
			<Modal.Header closeButton>
				<Modal.Title>Match with {matchTarget?.displayName}?</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				Do you want to match with <strong>{matchTarget?.displayName}</strong>? This will expose your WhatsApp number to
				them.
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onCancel}>
					Cancel
				</Button>
				<Button variant="primary" onClick={onConfirm} disabled={matching}>
					{matching ? "Matching..." : "Yes, Match!"}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
